<div class="row" [class.subody]="user.subscribe">

  <!-- LEFT SIDE -->
  <div class="col-lg-8">

    <div class="card payment-card">

      <div class="card-body p-4">

        <h3 class="mb-3">
          Complete Your Subscription
        </h3>

        <span class="plan-badge">
          {{getPackName()}}
        </span>

        <hr>

        <!-- Billing Details -->

        <h5 class="mb-3">
          Billing Information
        </h5>

        <div class="row">

          <div class="col-md-6 mb-3">
            <label>Organization Name</label>
            <input type="text" class="form-control" [(ngModel)]="formData.billing.billing_name">
          </div>

          <div class="col-md-6 mb-3">
            <label>GST Number</label>
            <input type="text" class="form-control" [(ngModel)]="formData.billing.gst_no">
          </div>

          <div class="col-md-6 mb-3">
            <label>Contact Person</label>
            <input type="text" class="form-control" [(ngModel)]="formData.contacts[0].person_name">
          </div>

          <div class="col-md-6 mb-3">
            <label>Email Address</label>
            <input type="email" class="form-control" [(ngModel)]="formData.contacts[0].email_id">
          </div>

          <div class="col-md-6 mb-3">
            <label>Mobile Number</label>
            <input type="text" class="form-control" [(ngModel)]="formData.contacts[0].mobile_no1">
          </div>

          <div class="col-md-6 mb-3">
            <label>Country</label>
            <select class="form-select">
              <option>India</option>
            </select>
          </div>

        </div>

        <hr>

        <!-- Coupon -->

        <h5>Coupon Code</h5>

        <div class="input-group mb-4">
          <input type="text" class="form-control" [(ngModel)]="formData.package.couponCode" placeholder="Enter Coupon Code"
            [disabled] = "this.formData.package.discount_amount">
          <button class="btn btn-primary" (click)="applyCoupon()" [disabled]="this.formData.package.discount_amount">
            Apply
          </button>
        </div>

        <hr>

        <!-- Payment Methods -->

        <!-- <h5 class="mb-3">
          Select Payment Method
        </h5> -->

        <!-- <div class="row g-2 mb-3">

          <div class="col-md-3">
            <button class="btn btn-sm btn-outline-primary w-100 payment-btn active" data-target="cardSection">
              💳 Card
            </button>
          </div>

          <div class="col-md-3">
            <button class="btn btn-sm btn-outline-primary w-100 payment-btn" data-target="upiSection">
              📱 UPI
            </button>
          </div>

          <div class="col-md-3">
            <button class="btn btn-sm btn-outline-primary w-100 payment-btn" data-target="netbankingSection">
              🏦 Net Banking
            </button>
          </div>

          <div class="col-md-3">
            <button class="btn btn-sm btn-outline-primary w-100 payment-btn" data-target="walletSection">
              👛 Wallet
            </button>
          </div>

          <div class="col-md-3">
            <button class="btn btn-sm btn-outline-primary w-100 payment-btn" data-target="emiSection">
              📄 EMI
            </button>
          </div>

          <div class="col-md-3">
            <button class="btn btn-sm btn-outline-primary w-100 payment-btn" data-target="internationalSection">
              🌍 International
            </button>
          </div>

          <div class="col-md-3">
            <button class="btn btn-sm btn-outline-primary w-100 payment-btn" data-target="bankTransferSection">
              🏧 Bank Transfer
            </button>
          </div>

          <div class="col-md-3">
            <button class="btn btn-sm btn-outline-primary w-100 payment-btn" data-target="autoRenewSection">
              🔄 Auto Renewal
            </button>
          </div>

        </div>

        <hr>

        <div id="cardSection" class="payment-section">

          <h5>Card Details</h5>

          <div class="row">

            <div class="col-12 mb-3">
              <input type="text" class="form-control" placeholder="Card Number">
            </div>

            <div class="col-md-6 mb-3">
              <input type="text" class="form-control" placeholder="Card Holder Name">
            </div>

            <div class="col-md-3 mb-3">
              <input type="text" class="form-control" placeholder="MM/YY">
            </div>

            <div class="col-md-3 mb-3">
              <input type="password" class="form-control" placeholder="CVV">
            </div>

          </div>

        </div>

        <div id="upiSection" class="payment-section d-none">

          <h5>UPI Payment</h5>

          <div class="mb-3">

            <label class="form-label">
              UPI ID
            </label>

            <input type="text" class="form-control" placeholder="yourname@upi">

          </div>

          <div class="text-center">

            <h6>OR</h6>

            <img src="images/qr.png" class="img-fluid">

            <p class="mt-2">
              Scan QR Code
            </p>

          </div>

        </div>

        <div id="netbankingSection" class="payment-section d-none">

          <h5>Select Bank</h5>

          <select class="form-select">

            <option>SBI</option>
            <option>HDFC Bank</option>
            <option>ICICI Bank</option>
            <option>Axis Bank</option>
            <option>Punjab National Bank</option>

          </select>

        </div>

        <div id="walletSection" class="payment-section d-none">

          <h5>Select Wallet</h5>

          <div class="row g-3">

            <div class="col-md-4">
              <button class="btn btn-outline-secondary w-100">
                Paytm
              </button>
            </div>

            <div class="col-md-4">
              <button class="btn btn-outline-secondary w-100">
                PhonePe
              </button>
            </div>

            <div class="col-md-4">
              <button class="btn btn-outline-secondary w-100">
                Amazon Pay
              </button>
            </div>

          </div>

        </div>

        <div id="emiSection" class="payment-section d-none">

          <h5>EMI Options</h5>

          <select class="form-select mb-3">

            <option>3 Months EMI</option>
            <option>6 Months EMI</option>
            <option>9 Months EMI</option>
            <option>12 Months EMI</option>

          </select>

        </div>

        <div id="internationalSection" class="payment-section d-none">

          <div class="alert alert-info">

            International cards accepted.
            Currency conversion charges may apply.

          </div>

        </div>

        <div id="bankTransferSection" class="payment-section d-none">

          <div class="card bg-light">

            <div class="card-body">

              <h6>Bank Account Details</h6>

              <p>
                Account Name : ABC ERP Solutions
                <br>
                Account No : 1234567890
                <br>
                IFSC : HDFC0000123
                <br>
                Bank : HDFC Bank
              </p>

            </div>

          </div>

          <div class="mt-3">

            <label>
              Upload Payment Proof
            </label>

            <input type="file" class="form-control">

          </div>

        </div> -->

        <div id="autoRenewSection" class="payment-section">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" [ngModel]="formData.package.auto_renew">
            <label class="form-check-label">
              Enable Auto Renewal
            </label>
          </div>

          <p class="text-muted mt-2">
            Your subscription will automatically renew before expiry.
          </p>
        </div>

        <div class="form-check mt-3">
          <input class="form-check-input" type="checkbox" [ngModel]="formData.package.save_paym">
          <label class="form-check-label">
            Save payment method for future renewals
          </label>
        </div>

      </div>
    </div>
  </div>

  <!-- RIGHT SIDE -->
  <div class="col-lg-4 mt-4 mt-lg-0">
    <div class="card payment-card">
      <div class="card-body p-4">
        <h4>
          Payment Summary
        </h4>
        <hr>
        <div class="summary-row">
          <span>Plan</span>
          <strong>{{getPackName()}}</strong>
        </div>

        <div class="summary-row">
          <span>Subscription</span>
          <span>{{formData.package.bill_cycle}}</span>
        </div>

        <div class="summary-row">
          <span>Students</span>
          <span>{{formData.package.std_counts}}</span>
        </div>

        <div class="summary-row">
          <span>Base Amount</span>
          <span>₹{{formData.package.base_amount}}</span>
        </div>

        <div class="summary-row">
          <span>Modules Amount</span>
          <span>₹{{formData.package.module_amount}}</span>
        </div>

        <div class="summary-row">
          <span>Discount Amount (-)</span>
          <span>₹{{formData.package.discount_amount || '0.00'}}</span>
        </div>

        <div class="summary-row">
          <span>GST (18%)</span>
          <span>₹{{formData.package.tax_amount}}</span>
        </div>

        <hr>

        <div class="summary-row">
          <strong>Total Payable</strong>
          <strong class="text-primary">
            ₹{{formData.package.total_amount}}
          </strong>
        </div>

        <button class="btn btn-sm btn-primary btn-lg w-100 mt-3" (click)="payNow()">
          Pay Securely Now
        </button>

        <div class="text-center mt-3">
          <div class="secure-badge">
            🔒 256-bit SSL Secure Payment
          </div>
        </div>

        <hr>

        <h6>
          Accepted Payment Methods
        </h6>

        <div class="d-flex flex-wrap gap-2 mt-3">
          <span class="badge bg-primary">Visa</span>
          <span class="badge bg-dark">MasterCard</span>
          <span class="badge bg-success">UPI</span>
          <span class="badge bg-info">RuPay</span>
          <span class="badge bg-warning text-dark">Paytm</span>
          <span class="badge bg-secondary">PhonePe</span>
          <span class="badge bg-danger">NetBanking</span>
        </div>

        <hr>
        <small class="text-muted">
          By proceeding you authorize recurring
          subscription billing as per selected plan.
        </small>
      </div>
    </div>
  </div>
</div>
